import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Joi from "joi-browser";
import Form from  './common/form';
import http from "../services/httpService";

const apiEndpointChildCategory = "child_categories";
const apiEndpointEmailCategory = "email_categories";

class AddCategoryModal extends Form {
    state = {
      data: { email_id: this.props.emailId,
              parent_category_id: "", 
              child_category_name: "" },
      errors: {}
    };
    
    schema = {
      email_id: Joi.number()
        .required()
        .label("Email ID"),
      parent_category_id: Joi.string()
        .required()
        .label("Category Name"),
      child_category_name: Joi.string()
        .required()
        .label("Category Value"),
    };

    doSubmit = async () => {
        const { parent_category_id, child_category_name: name, email_id } = this.state.data;
        const { data: { child_category: { id: category_id }}} = 
            await http.post(apiEndpointChildCategory, {
                parent_category_id, name
            });
        console.log(category_id);
        const response =  await http.post(apiEndpointEmailCategory, {
            email_id,
            category_id
        });
        console.log(response);
        this.props.handleSave();
    };

    render() {
        const { emailId, show, handleClose, parentCategories } = this.props;
        return (
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Add Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form id={ emailId } onSubmit={this.handleSubmit}>
                  {this.renderSelect("parent_category_id", 
                                     "Category Name",
                                     parentCategories)}
                  {this.renderInput("child_category_name", "Category Value")}
                </form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              {this.renderButton("Save", {
                form: emailId,
                onClick: handleClose
              })}
            </Modal.Footer>
          </Modal>
        );
    }
}

export default AddCategoryModal;